import React from 'react';
import './Loader.scss';
import Lottie from 'lottie-react';
import progressAnimation from '@/assets/animation/loading.json';
export type LoaderProps = {
  text?: string;
};

export const Loader = ({ text = 'Saving...' }: LoaderProps) => {
  return (
    <span className="loader-progress">
      <Lottie className="loader-animation" animationData={progressAnimation} />
      <span>{text}</span>
    </span>
  );
};
